import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from './layout/app.layout.component';
import { LoginComponent } from './features/auth/login/login.component';
import { PaymentSuccessComponent } from './features/payments/payment-success/payment-success.component';
import { PaymentFailedComponent } from './features/payments/payment-failed/payment-failed.component';
import { PaymentPageComponent } from './features/payments/payment-page/payment-page.component';
import { ReportsPageComponent } from './features/reports/reports-page/reports-page.component';
import { WebPurchasesComponent } from './features/web-purchases/web-purchases.component';
import { AuthGuard } from './core/auth/auth.guard';

@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                { path: '', component: LoginComponent },
                { path: 'eft-pay', component: PaymentPageComponent },
                {
                    path: 'payment-success',
                    component: PaymentSuccessComponent,
                },
                {
                    path: 'web-purchases',
                    loadChildren: () =>
                        import(
                            './features/web-purchases/web-purchases.module'
                        ).then((m) => m.WebPurchasesModule),
                },
                {
                    path: 'home',
                    component: AppLayoutComponent,
                    canActivate: [AuthGuard],
                    canActivateChild: [AuthGuard],
                    children: [
                        {
                            path: 'reports',
                            component: ReportsPageComponent,
                        },
                        {
                            path: '',
                            loadChildren: () =>
                                import(
                                    './features/customers/customer.module'
                                ).then((m) => m.CustomerModule),
                        },
                        {
                            path: 'partners',
                            loadChildren: () =>
                                import(
                                    './features/partners/partners.module'
                                ).then((m) => m.PartnersModule),
                        },
                        {
                            path: 'users',
                            loadChildren: () =>
                                import(
                                    './features/users/users.module'
                                ).then((m) => m.UsersModule),
                        },
                    ],
                },
                {
                    path: 'auth',
                    loadChildren: () =>
                        import('./features/auth/auth.module').then(
                            (m) => m.AuthModule
                        ),
                },
                {
                    path: 'password-reset',
                    loadChildren: () =>
                        import(
                            './features/auth/password-reset/password-reset.module'
                        ).then((m) => m.PasswordResetModule),
                },
                { path: '**', redirectTo: '/notfound' },
            ],
            {
                scrollPositionRestoration: 'enabled',
                anchorScrolling: 'enabled',
                onSameUrlNavigation: 'reload',
            }
        ),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
